import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './assets/translations/en.json';
import translationNL from './assets/translations/nl.json';
import translationFR from './assets/translations/fr.json';

const allowedLanguages = ['en', 'nl', 'fr'];

//? default language selected
const defaultLng = 'nl';
let lng = defaultLng;

const storageLanguage = localStorage.getItem('language');

if (storageLanguage && allowedLanguages.indexOf(storageLanguage) > -1) {
	lng = storageLanguage;
}

const resources = {
	en: {
		translation: translationEN,
	},
	nl: {
		translation: translationNL,
	},
  fr: {
    translation: translationFR,
  }
};

export default i18next.use(initReactI18next).init({
	lng,
	// debug: true,
	resources,
	interpolation: {
		escapeValue: false,
	},
});
